import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OrderSuccess.css';

function OrderSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId || 'N/A';
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Simulate loading animation
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
      setTimeout(() => setShowContent(true), 300);
    }, 1500);

    return () => clearTimeout(loadingTimer);
  }, []);

  return (
    <div className="order-success-page">
      <div className="container">
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <p className="loading-text">Processing your order...</p>
          </div>
        ) : (
          <div className={`success-content ${showContent ? 'fade-in' : ''}`}>
            <div className="success-icon-wrapper">
              <div className="success-icon-circle">
                <svg 
                  className="checkmark" 
                  width="60" 
                  height="60" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle className="checkmark-circle" cx="12" cy="12" r="10" />
                  <polyline className="checkmark-check" points="9 12 11 14 15 10" />
                </svg>
              </div>
            </div>

            <h1 className="success-title">Order Placed Successfully!</h1>
            <p className="success-message">
              Thank you for your purchase. Your order has been received and is being processed.
            </p>
            
            <div className="order-id-container">
              <span className="order-id-label">Order ID</span>
              <span className="order-id-value">{orderId}</span>
            </div>

            <p className="success-submessage">
              You will receive an email confirmation shortly with your order details.
            </p>

            <div className="success-actions">
              <button className="btn btn-primary" onClick={() => navigate('/shop')}>
                Continue Shopping
              </button>
              <button className="btn btn-outline" onClick={() => navigate('/')}>
                Back to Home
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderSuccess;



